import { render, staticRenderFns } from "./OnboardingStep0.vue?vue&type=template&id=63367c94"
import script from "./OnboardingStep0.vue?vue&type=script&lang=js"
export * from "./OnboardingStep0.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports